import Image from "next/image";

export default function Logo(props) {
    let image;
    if (props.icon) {
        // image = "believemy-excitation.svg";
        image = "icon.svg";
        // let image = "believemyoctobreprimary.svg";

        if (props.white) {
            image = "icon-white.svg";
            // image = "believemyoctobrewhite.svg";
        }

        if (props.purple) {
            image = "icon.svg";
            // image = "believemyoctobrewhite.svg";
        }

        if (props.excitation) {
            image = "icon.svg";
        }
    } else {
        // image = "believemy-row-purple.svg";
        // image = "believemy-newblack.png";
        // image = "believemy-new-logo-black.svg";
        image = "believemy-new-logo-full-black.svg";
        // let image = "believemyoctobreprimary.svg";

        if (props.white) {
            // image = "believemy-row-white.svg";
            // image = "believemy-new-logo-white.svg";
            // image = "believemyoctobrewhite.svg";
            image = "believemy-new-logo-full-white.svg";
        }

        if (props.purple) {
            image = "believemy-row-purple.svg";
        }
    }

    return (
        <span style={{ lineHeight: 0 }} className={props.className}>
            {!props.icon ? (
                <Image
                    src={`/images/site/brand/${image}`}
                    alt="Believemy"
                    width={150 * (props.ratio || 1)}
                    // Proportions réelles du logo (486,6 × 91,5) : avec 30, la
                    // hauteur était recalculée par height: auto et Next.js
                    // signalait une image déformée.
                    height={Math.round(150 * (props.ratio || 1) * (91.5 / 486.6))}
                    style={{
                        maxWidth: "100%",
                        height: "auto",
                    }}
                    priority={props.priority || false}
                />
            ) : (
                <Image
                    src={`/images/site/brand/${image}`}
                    alt="Believemy"
                    width={30 * (props.ratio || 1)}
                    height={40.35 * (props.ratio || 1)}
                    style={{
                        maxWidth: "100%",
                        height: "auto",
                    }}
                    priority={props.priority || false}
                />
            )}
        </span>
    );
}
